interface ICurrency {
  label: string
  icon: string
}

const currencies: ICurrency[] = [
  {
    label: 'RUB',
    icon: '/images/flags/russia.svg',
  },
  {
    label: 'CNY',
    icon: '/images/flags/china.svg',
  },
  {
    label: 'PTE',
    icon: '/images/flags/portugal.svg',
  },
]

export const currenciesWithTranslations = [
  {
    code: 'INR',
    // t('main:currenciesRupee')
    translationKey: 'main:currenciesRupee',
  },
  {
    code: 'MYR',
    // t('main:currenciesrInggit')
    translationKey: 'main:currenciesrInggit',
  },
  {
    code: 'VND',
    // t('main:currenciesDong')
    translationKey: 'main:currenciesDong',
  },
  {
    code: 'IDR',
    // t('main:currenciesRupiah')
    translationKey: 'main:currenciesRupiah',
  },
  {
    code: 'BDT',
    // t('main:currenciesTaka')
    translationKey: 'main:currenciesTaka',
  },
  {
    code: 'BRL',
    // t('main:currenciesReal')
    translationKey: 'main:currenciesReal',
  },
  {
    code: 'ETB',
    // t('main:currenciesBirr')
    translationKey: 'main:currenciesBirr',
  },
  {
    code: 'GHS',
    // t('main:currenciesCedi')
    translationKey: 'main:currenciesCedi',
  },
  {
    code: 'KES',
    // t('main:currenciesShilling')
    translationKey: 'main:currenciesShilling',
  },
]

export default currencies
